import { render, staticRenderFns } from "./providers.vue?vue&type=template&id=b08e9b8c&scoped=true&"
import script from "./providers.vue?vue&type=script&lang=js&"
export * from "./providers.vue?vue&type=script&lang=js&"
import style0 from "./providers.vue?vue&type=style&index=0&id=b08e9b8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08e9b8c",
  null
  
)

export default component.exports